const ConfigBank = () => {
  return (
    <div className="config-bank">
      <h1>Placeholder for Bank Configuration</h1>
    </div>
  );
};

export default ConfigBank;
